import { fiveSlotLayout } from './fiveSlotLayout';
import { sixSlotLayout } from './sixSlotLayout';
import { sevenSlotLayout } from './sevenSlotLayout';
import { eightSlotLayout } from './eightSlotLayout';
import { nineSlotLayout } from './nineSlotLayout';
import { liveBlogLayouts } from './liveBlogLayouts';

export const getLayout = (type, totalTeases) => {
  if (type === 'liveBlog') {
    return liveBlogLayouts[totalTeases];
  }

  switch (totalTeases) {
    default:
      return fiveSlotLayout;
    case 5:
      return fiveSlotLayout;
    case 6:
      return sixSlotLayout;
    case 7:
      return sevenSlotLayout;
    case 8:
      return eightSlotLayout;
    case 9:
      return nineSlotLayout;
  }
};
